'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');

var Inspiration = function (_a) {
    var className = _a.className, restProps = tslib_es6.__rest(_a, ["className"]);
    return (React.createElement("div", { className: className },
        React.createElement("svg", tslib_es6.__assign({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" }, restProps),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m24.986 25.225.551-.237A4.686 4.686 0 0 0 23.684 16a4.684 4.684 0 0 0-1.853 8.988l.55.237.05.598.279 3.335h1.949l.278-3.335.05-.598Zm.593 4.933h-3.79l-.354-4.252A5.686 5.686 0 0 1 23.685 15a5.684 5.684 0 0 1 2.248 10.906l-.354 4.252Zm-3.79 1.763v-1h3.79v1h-3.79Zm.632.513v.5h2.526v-.5h-2.526Z", fill: "#323232" }))));
};

exports.default = Inspiration;
//# sourceMappingURL=index.js.map
